import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export default function ProtectedRoute() {
  const isAuthenticated = localStorage.getItem('admin_token') !== null;
  return isAuthenticated ? <Outlet /> : <Navigate to="/admin/login" replace />;
}
